<template>
  <div>
    <app-panel title="Отправка Email" class="employee-debtors-send-email-panel">

      <div class="employee-debtors-send-email-panel__row employee-debtors-send-email-panel__row_center">
        <vs-radio :vs-value="SEND_TYPE.house" v-model="sendType" name="sendType" style="margin-right: 15px">Отправить на
          дом
        </vs-radio>
        <vs-radio :vs-value="SEND_TYPE.email" v-model="sendType" name="sendType">Отправить на конкретный email</vs-radio>
      </div>

      <div class="employee-debtors-send-email-panel__row">
        <template v-if="sendType === SEND_TYPE.house">
          <building-form ref="buildingForm" :buildingsId.sync="buildingsId"/>
        </template>
        <template v-else-if="sendType === SEND_TYPE.email">
          <single-email-form ref="singleEmailForm"/>
        </template>

      </div>

      <div class="employee-debtors-send-email-panel__row">
        <app-redactor label="Текст" min-height="180px" v-model="text"/>
      </div>

      <div class="employee-debtors-send-email-panel__row employee-debtors-send-email-panel__row_center">
        <app-button color="success" @click="send">Отправить</app-button>
      </div>
    </app-panel>

    <history-panel :send-type="sendType" :buildingsId="buildingsId" style="margin-top: 15px"/>
  </div>
</template>

<script>
  import BuildingForm from "@/components/debtors/email/BuildingForm";
  import SingleEmailForm from "@/components/debtors/email/SingleEmailForm";
  import HistoryPanel from "@/components/debtors/email/HistoryPanel";

  const SEND_TYPE = {
    house: 0,
    email: 1
  };


  export default {
    name: "SendEmail",
    components: {
      BuildingForm,
      SingleEmailForm,
      HistoryPanel
    },
    data() {
      return {
        buildingsId: null,
        sendType: SEND_TYPE.house,
        text: "",
        SEND_TYPE: SEND_TYPE
      }
    },
    computed: {},
    methods: {
      resetAllErrors() {
        if (this.$refs.buildingForm) {
          this.$refs.buildingForm.resetErrors();
        }
        if (this.$refs.singleEmailForm) {
          this.$refs.singleEmailForm.resetErrors();
        }
      },
      sendEmail() {
        let body = Object.assign({body: this.text}, this.$refs.singleEmailForm.getBody());
        return this.$http.post('send_one_mail', body);
      },
      sendHouseEmail() {
        let body = Object.assign({body: this.text}, this.$refs.buildingForm.getBody());
        return this.$http.post('custom_mails', body);
      },
      async send() {
        try {

          if (this.sendType === SEND_TYPE.house) {
            if (this.$refs.buildingForm.checkErrors()) {
              return false;
            }
          } else if (this.sendType === SEND_TYPE.email) {
            if (this.$refs.singleEmailForm.checkErrors()) {
              return false;
            }
          }


          if (this.sendType === SEND_TYPE.email) {
            await this.sendEmail();
            this.$vs.notify({color: 'success', title: 'Письмо отправлено', text: 'Письмо успешно отправлено'});
          } else if (this.sendType === SEND_TYPE.house) {
            let {data} = await this.sendHouseEmail();
            this.$vs.notify({
              color: 'success',
              title: 'Письма отправлены',
              text: `${data.sent} писем успешно отправлено`
            });
          }
        } catch (e) {
          if (e.response) {
            if (e.response.status === 403) {
              this.$vs.notify({color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав'});
            } else if (e.response.status === 404) {
              this.$vs.notify({color: 'danger', title: 'Ошибка', text: e.response.data.message});
            } else {
              this.$vs.notify({color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже'});
            }
          } else {
            this.$vs.notify({color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка'});
          }
        }
      }
    },
    watch: {
      sendType() {
        this.resetAllErrors();
      }
    }
  }
</script>

<style lang="scss">
  .employee-debtors-send-email-panel {
    &__row {
      margin-bottom: 15px;

      &_center {
        text-align: center;
      }
    }

  }
</style>
